import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';
import { ResetPassword } from './components/ResetPassword';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      {window.location.pathname === '/reset-password' ? (
        <ResetPassword onSuccess={() => (window.location.href = '/')} />
      ) : (
        <App />
      )}
    </AuthProvider>
  </StrictMode>
);
